import { jsx } from "react/jsx-runtime";
import { memo, createElement } from "react";
import { useDataBinding } from "../accessorTree/useDataBinding.js";
import { AccessorTree } from "../accessorTree/AccessorTree.js";
const DataBindingProvider = memo(function DataBindingProvider2(props) {
  const accessorTreeState = useDataBinding(props);
  const children = "stateComponent" in props && props.stateComponent ? createElement(
    props.stateComponent,
    {
      ...props.stateProps,
      accessorTreeState
    },
    props.children
  ) : props.children;
  return /* @__PURE__ */ jsx(AccessorTree, { state: accessorTreeState, children });
});
export {
  DataBindingProvider
};
//# sourceMappingURL=DataBindingProvider.js.map
